import { Bell, CalendarCheck, Zap } from "lucide-react";
import { Img } from "./Img";
import { InstallButton } from "./InstallButton";

const perks = [
  { icon: Zap, text: "Opens instantly — no app store, no updates" },
  { icon: CalendarCheck, text: "Your mats and schedule one tap away" },
  { icon: Bell, text: "Waitlist and favorite-mat alerts in your message center" },
];

export const AppDownload = () => {
  return (
    <section data-testid="app-download" className="relative bg-black py-24 sm:py-32 border-t border-neutral-900 overflow-hidden">
      <Img name="m2" alt="" aria-hidden="true" sizes="100vw" className="absolute inset-0 w-full h-full object-cover opacity-20" />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40" />

      <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.35em] text-neon mb-5">In your pocket</p>
          <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9] mb-6">
            Put <span className="text-stroke-neon">Sculpt</span> on your home screen
          </h2>
          <p className="text-base lg:text-lg text-neutral-400 font-light max-w-xl mb-8">
            Add Sculpt Fusion to your phone like any other app — book your mat, switch spots and check your reservations with a single tap.
          </p>

          <ul className="space-y-3 mb-10" data-testid="install-perks">
            {perks.map(({ icon: Icon, text }) => (
              <li key={text} className="flex items-center gap-3 text-sm text-neutral-300">
                <span className="w-8 h-8 border border-neon/40 bg-neon/10 text-neon flex items-center justify-center shrink-0"><Icon size={14} /></span>
                {text}
              </li>
            ))}
          </ul>

          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
            <InstallButton />
            <span className="text-[11px] uppercase tracking-[0.2em] text-neutral-500">Works on iPhone, Android &amp; desktop</span>
          </div>
        </div>
      </div>
    </section>
  );
};
